module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/~/babel-runtime/core-js/object/create.js
 ** module id = 918
 ** module chunks = 0
 **/